const getInitials = str =>
  str
    .replace(/SA|SL|SRL|S\.A|S\.L/g, '')
    .split(' ')
    .slice(0, 2)
    .map(str => str[0])
    .join('')
    .toLocaleUpperCase()

export default getInitials
